import React, { useEffect, useState } from "react";
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faUserTie, faCirclePause } from '@fortawesome/free-solid-svg-icons';
import NewRegistrationModal from "components/Private/NewRegistrationModal";
import Swal from 'sweetalert2';
import EditGuestModal from "components/Private/EditGuestModal";
import { useGuestContext } from '../../contexts/GuestContext';
// react-bootstrap components
import {
    Modal,
    Button,
    Card,
    Nav,
    Container,
    Dropdown,
    Row,
    Col,
    OverlayTrigger, Tooltip
} from "react-bootstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import SheetUpload from "components/Private/SheetUpload";
import { Scrollbars } from 'react-custom-scrollbars';
// core components
import ReactTable from "../../components/ReactTable/ReactTable";

function AdminUserMgmt() {

    const [refreshDataTrigger, setRefreshDataTrigger] = useState(0);
    const { language, setPageBanner, setLoading } = useGuestContext();
    const [modal, setModal] = React.useState(false);
    const [uploadModal, setUploadModal] = React.useState(false);
    const [editGuestModal, setEditGuestModal] = React.useState(false);
    const [alert, setAlert] = React.useState(null);
    const [registrations, setRegistrations] = useState([]); // state for holding fetched data

    const [selectedRegistration, setSelectedRegistration] = useState(null);


    const hideAlert = () => {
        setAlert(null);
    };

    const handleEditClick = (guestId, response) => {
        console.log('Edit clicked for guest:', guestId);
        const registrationData = response.data.find(registration => registration.id === guestId);
        setSelectedRegistration(registrationData);
        setEditGuestModal(!editGuestModal);
    };


    const handleDeleteClick = (guestId) => {
        const htmlContent = language === "English" ?
            `Are you sure you would like to delete the registration of <strong style="color: #007bff;">Guest ID: ${guestId}</strong>?` :
            `您確定要刪除 <strong style="color: #007bff;">Guest ID：${guestId}</strong> 的報名嗎？`;

        Swal.fire({
            title: language === "English" ? "Delete Confirmation" : "確認要刪除嗎？",
            html: htmlContent,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: language === "English" ? "Confirm Deletion" : "確認刪除報名",
            cancelButtonText: language === "English" ? "Cancel" : "取消"
        }).then((result) => {
            if (result.isConfirmed) {
                deleteRegistration(guestId);
            } else {
                hideAlert();
            }
        });
    };

    const successDelete = (guestId) => {
        const htmlContent = language === "English" ?
            `The registration of <strong style="color: #007bff;">Guest ID: ${guestId}</strong> is deleted.` :
            `<strong style="color: #007bff;">Guest ID：${guestId}</strong> 的報名已被刪除。`;

        Swal.fire({
            title: "Deleted!",
            html: htmlContent,
            icon: 'success',
            confirmButtonColor: '#17a2b8', // Using a color for the confirm button (Bootstrap's info color)
            confirmButtonText: language === "English" ? "OK" : "好的"
        }).then(() => {
            hideAlert();
        });
    };

    const deleteRegistration = async (guestId) => {
        try {
            setLoading(true); // Start loading (if you have a loading state)
            await axios.delete(`${process.env.REACT_APP_SERVER_URL}/event/delete-registration/${guestId}`);
            successDelete(guestId);
            setLoading(false); // Stop loading (if you have a loading state)
            setRefreshDataTrigger(prev => prev + 1);
        } catch (error) {
            console.error('Error deleting registration:', error);
            setLoading(false); // Stop loading (if you have a loading state)
            // Handle error here, maybe show an error alert
        }
    }

    useEffect(() => {
        const fetchRegistrations = async () => {
            try {
                setLoading(true); // If you have a loading state
                const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/event/getadmins`);
                const formattedData = response.data.map((registration, index) => ({
                    id: String(registration.id).padStart(4, '0'),
                    name: `${registration.firstname} ${registration.lastname}`,
                    email: registration.email,
                    phone: registration.phone,
                    isVolunteering: registration.isVolunteering ? "Yes" : "No",
                    actions: (
                        <div className="actions-right">
                            {/* Edit */}
                            <Button
                                onClick={() => handleEditClick(registration.id, response)}
                                // variant="warning"
                                size="sm"
                                className="text-success btn-link edit"
                            >
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id={`tooltip`}>
                                            Edit
                                        </Tooltip>
                                    }
                                >
                                    <i className="fa fa-edit" />
                                </OverlayTrigger>
                            </Button>{" "}


                            {/* checkin guest */}
                            <Button
                                // onClick={() => handleCheckInClick(registration.id)}
                                // variant="info"
                                size="sm"
                                className="text-warning btn-link like"
                            >
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id={`tooltip`}>
                                            Suspend this Administrator
                                        </Tooltip>
                                    }
                                >
                                    <FontAwesomeIcon icon={faCirclePause} />
                                </OverlayTrigger>

                            </Button>{" "}
                            {/* Delete Registration */}
                            <Button
                                variant="danger"
                                size="sm"
                                className="btn-link remove text-danger"
                                onClick={() => handleDeleteClick(registration.id)}
                            >
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id={`tooltip`}>
                                            Delete Guest Registration
                                        </Tooltip>
                                    }
                                >
                                    <i className="fa fa-times" />
                                </OverlayTrigger>
                            </Button>{" "}
                        </div>
                    )
                }));
                setRegistrations(formattedData);
                setLoading(false); // If you have a loading state
            } catch (error) {
                console.error('Error fetching registration data:', error);
                setLoading(false); // If you have a loading state
            }
        };
        fetchRegistrations();
        console.log(registrations)
    }, [refreshDataTrigger]);

    const dropdownContent = (
        <>
            <Dropdown as={Nav.Item}>
                <Dropdown.Toggle as={Button} variant="info" className="btn-wd mr-1 btn-outline font-weight-bold" id="regPageAction">
                    Actions
                    <span className="dropdown-arrow ml-2">
                        <i className="nc-icon nc-minimal-down"></i>
                    </span>
                </Dropdown.Toggle>
                <Dropdown.Menu alignRight aria-labelledby="navbarDropdownMenuLink">
                    <Dropdown.Item className="text-default" href="#pablo" onClick={e=>e.preventDefault()}>
                    <i className="nc-icon nc-satisfied"></i>
                         添加管理員
                    </Dropdown.Item>
                    <Dropdown.Item className="text-default" href="#pablo" onClick={e=>e.preventDefault()}>
                        <i className="nc-icon nc-cloud-download-93"></i>
                        下載信息
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </>
    )
    return (
        <>
            {alert}
            {/* {alertState} */}
            <Container fluid>
                <Row>
                    <Col md="12">
                        <Card>
                            <Card.Header>
                                <div className="d-flex justify-content-between align-items-center">
                                    <h4 className="title font-weight-bold">管理員列表</h4>
                                    {dropdownContent}
                                </div>
                            </Card.Header>
                            <hr />
                            <Card.Body >
                                {/* <Scrollbars style={{ width: '80%', height: 1000}}> */}
                                <ReactTable
                                    data={registrations}
                                    columns={[
                                        {
                                            Header: "Display Name",
                                            accessor: "id",
                                        },
                                        {
                                            Header: "Full Name",
                                            accessor: "name",
                                        },
                                        {
                                            Header: "Phone",
                                            accessor: "phone",
                                        },
                                        {
                                            Header: "Registered Since",
                                            accessor: "isVolunteering",
                                        },
                                        {
                                            Header: "Last Login Time",
                                            accessor: "email",
                                        },
                                        {
                                            Header: "Actions",
                                            accessor: "actions",
                                            sortable: false,
                                            filterable: false,
                                        },
                                    ]}
                                    /*
                                      You can choose between primary-pagination, info-pagination, success-pagination, warning-pagination, danger-pagination or none - which will make the pagination buttons gray
                                    */
                                    className="-striped -highlight primary-pagination"
                                />
                                {/* </Scrollbars> */}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <NewRegistrationModal modal={modal} setModal={setModal} />
            <SheetUpload uploadModal={uploadModal} setUploadModal={setUploadModal} />
            <EditGuestModal editGuestModal={editGuestModal} setEditGuestModal={setEditGuestModal} registrationData={selectedRegistration} />
        </>
    );
}
export default AdminUserMgmt;
